/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_PreviousInputs */

const en_platform_rail_previous = /** @type {(inputs: Platform_Rail_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const pl_platform_rail_previous = /** @type {(inputs: Platform_Rail_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednie`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Platform_Rail_PreviousInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_previous = /** @type {((inputs?: Platform_Rail_PreviousInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_PreviousInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_previous(inputs)
	return en_platform_rail_previous(inputs)
});